import type { PixelSprite } from '../types.js';
import { sprites as appleBasket } from './appleBasket.js';
import { sprites as appleTree } from './appleTree.js';
import { sprites as barn } from './barn.js';
import { sprites as barnWinter } from './barnWinter.js';
import { sprites as beeFarm } from './beeFarm.js';
import { sprites as chicken } from './chicken.js';
import { sprites as cornStalk } from './cornStalk.js';
import { sprites as cow } from './cow.js';
import { sprites as donkey } from './donkey.js';
import { sprites as fence } from './fence.js';
import { sprites as gardenBed } from './gardenBed.js';
import { sprites as goat } from './goat.js';
import { sprites as harvestBasket } from './harvestBasket.js';
import { sprites as hayMaze } from './hayMaze.js';
import { sprites as haystack } from './haystack.js';
import { sprites as horse } from './horse.js';
import { sprites as kimchiGarden } from './kimchiGarden.js';
import { sprites as lamb } from './lamb.js';
import { sprites as lemonTree } from './lemonTree.js';
import { sprites as oliveTree } from './oliveTree.js';
import { sprites as orangeTree } from './orangeTree.js';
import { sprites as orchard } from './orchard.js';
import { sprites as peachTree } from './peachTree.js';
import { sprites as pearTree } from './pearTree.js';
import { sprites as pigpen } from './pigpen.js';
import { sprites as pumpkin } from './pumpkin.js';
import { sprites as pumpkinPatch } from './pumpkinPatch.js';
import { sprites as ricePaddy } from './ricePaddy.js';
import { sprites as riceTerrace } from './riceTerrace.js';
import { sprites as scarecrow } from './scarecrow.js';
import { sprites as scarecrowAutumn } from './scarecrowAutumn.js';
import { sprites as seedling } from './seedling.js';
import { sprites as sheep } from './sheep.js';
import { sprites as silo } from './silo.js';
import { sprites as sprout } from './sprout.js';
import { sprites as sunflower } from './sunflower.js';
import { sprites as trough } from './trough.js';
import { sprites as watermelon } from './watermelon.js';
import { sprites as wheat } from './wheat.js';
export const sprites: Readonly<Record<string, readonly PixelSprite[]>> = {
  appleBasket,
  appleTree,
  barn,
  barnWinter,
  beeFarm,
  chicken,
  cornStalk,
  cow,
  donkey,
  fence,
  gardenBed,
  goat,
  harvestBasket,
  hayMaze,
  haystack,
  horse,
  kimchiGarden,
  lamb,
  lemonTree,
  oliveTree,
  orangeTree,
  orchard,
  peachTree,
  pearTree,
  pigpen,
  pumpkin,
  pumpkinPatch,
  ricePaddy,
  riceTerrace,
  scarecrow,
  scarecrowAutumn,
  seedling,
  sheep,
  silo,
  sprout,
  sunflower,
  trough,
  watermelon,
  wheat,
};
